export default "__VITE_ASSET__VgvVhENF__"